<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 9 9"
    fill="none"
    v-bind="$attrs"
    :width="width"
    :height="height"
  >
    <path
      d="M8.1 0L2.52 6.13635L0.9 4.90935H0L2.52 9L9 0H8.1Z"
      :fill="fill"
    />
  </svg>
</template>

<script lang="ts" setup>
defineProps({
  width: {
    type: [String, Number],
    default: 9,
  },
  height: {
    type: [String, Number],
    default: 9,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
});
</script>